module.exports = __webpack_public_path__ + "img/vision.9b11530d.png";